import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const SocialInstagramIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M17.1745 11.9996C17.1694 9.1446 14.8544 6.83155 11.9994 6.82755C9.1444 6.83256 6.83236 9.14561 6.82835 11.9996C6.83135 14.8546 9.1454 17.1696 12.0004 17.1737C14.8564 17.1696 17.1704 14.8556 17.1745 11.9996ZM11.9994 15.1611C10.2543 15.1621 8.83886 13.7476 8.83786 12.0016C8.83786 10.2565 10.2523 8.84105 11.9984 8.84004C11.9984 8.84004 10.2533 8.83904 11.9994 8.84004C13.7454 8.84105 15.1599 10.2565 15.1599 12.0016C15.1589 13.7466 13.7444 15.1611 11.9994 15.1611Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
          <path
            d="M18.4209 6.86702C18.4209 6.18282 17.867 5.62785 17.1828 5.62785C16.4976 5.62785 15.9436 6.18282 15.9436 6.86702C15.9436 7.55121 16.4976 8.10619 17.1828 8.10619C17.867 8.10619 18.4209 7.55121 18.4209 6.86702Z"
            fill="#222"
          />
          <path
            d="M7.95743 2H16.0416C19.3303 2.00401 21.996 4.66867 22 7.95743V16.0416C21.997 19.3303 19.3313 21.996 16.0426 22H7.95843C4.66967 21.997 2.00401 19.3313 2 16.0426V7.95943C2.00301 4.66967 4.66867 2.00401 7.95743 2ZM16.0416 19.9885C18.2214 19.9885 19.9885 18.2224 19.9885 16.0416V7.95943C19.9885 5.77961 18.2214 4.01252 16.0426 4.01152H7.95843C5.77861 4.01152 4.01252 5.77861 4.01152 7.95743V16.0416C4.01152 18.2214 5.77761 19.9875 7.95743 19.9885H16.0416Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
        </svg>
      </IconWrapper>
    )
  },
)
